import gql from 'graphql-tag';

import { useSolQuery } from '@/hooks/useSolQuery';

import type { PipelineWeeklyTrendsGQLResponse } from './pipelineType';

export const usePipelineWeeklyTrends = (startDate?: string, endDate?: string) => {
  const canExecuteQuery = startDate?.length && endDate?.length;

  const { data, isLoading, error } = useSolQuery<PipelineWeeklyTrendsGQLResponse>({
    query:
      !!canExecuteQuery &&
      gql`
        query PipelineWeeklyTrends($startDate: DateTime, $endDate: DateTime) {
          visualization {
            pipelineTrends(startDate: $startDate, endDate: $endDate) {
              sundayOfWeek
              returnOnSpend
              costPerOpportunity
            }
          }
        }
      `,
    variables: {
      startDate: startDate + 'T00:00:00Z',
      endDate: endDate + 'T23:59:59Z',
    },
  });

  return {
    pipelineWeeklyTrends: data?.visualization.pipelineTrends,
    isLoading,
    error,
  };
};
